<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-app id="app">
      <v-snackbar
        v-model="showSnackBar"
        color="#FF1313"
        right
        :timeout="timeout"
      >
        <v-layout wrap justify-center>
          <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
          <v-flex text-right>
            <v-btn small :ripple="false" text @click="showSnackBar = false">
              <v-icon style="color: white">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-snackbar>
      <v-divider></v-divider>
      <!-- <AppHeader v-if="$route.path != '/'" @stepper="winStepper" /> -->

      <AppHeader
        v-if="appUserType == 'Client' && $route.name != 'Login'"
        @stepper="winStepper"
      />

      <AppHeader2
        v-if="
          appUserType == 'seller' &&
            $route.name != 'Login' &&
            $route.path != '/' &&
            appuserStat == 'active'
        "
      />
      <AppHeader3
        v-if="
          appUserType == 'seller' &&
            $route.name != 'Login' &&
            $route.path != '/' &&
            appuserStat != 'active'
        "
      />
      <router-view
        :style="$vuetify.breakpoint.name == 'md' ? 'padding-top:50px' : ''"
        style="min-height: 80vh"
        :key="$route.fullPath"
        v-bind:storage="sideNav"
      />
      <AppFooter />
    </v-app>
    <!-- <AppFooter v-if="$route.name != 'Login'" v-bind:storage="styloopData" /> -->
  </div>
</template>
<script>
// import AppMainHeader from "./components/Common/appHeader0";
import AppHeader from "./components/Common/appHeader";
import AppHeader2 from "./components/Common/appHeader2";
import AppHeader3 from "./components/Common/appHeader3";
import AppFooter from "./components/Common/appFooter";
// import QueryPopUp from "./components/Common/queryPopUp";
import axios from "axios";

import "./assets/styles/fonts.css";
import "./assets/styles/appStyle.css";

export default {
  components: {
    // AppMainHeader,
    AppHeader,
    AppHeader2,
    AppHeader3,
    AppFooter,

    // QueryPopUp,
  },
  data() {
    return {
      sideNav: false,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      msg: null,
      timeout: 5000,
      styloopData: {},
      queryPopUpDialog: false,
    };
  },

  computed: {
    appUserType() {
      return this.$store.state.userType;
    },
    appuserStat() {
      return this.$store.state.userDetailed.profileStatus;
      // return localStorage.getItem("profStat");
    },
  },
  beforeMount() {
    // this.getSettings();
    if (typeof localStorage.getItem("token") == "string") {
      this.getProfile();
      // } else {
      //   this.$store.commit("userType", "Client");
      //   if (this.getCookie("LookingFor") == "false") {
      //     return;
      //   } else {
      //     setTimeout(() => {
      //       this.queryPopUpDialog = true;
      //     }, 10000);
      //   }
    }
  },
  methods: {
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2)
        return parts
          .pop()
          .split(";")
          .shift();
    },
    getProfile() {
      axios({
        method: "post",
        url: "user/me",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            localStorage.setItem("userid", response.data.data._id);
            this.$store.commit("loginUser", response.data.status);
            this.$store.commit("userData", response.data.data.sellerid);
            this.$store.commit("userDetailed", response.data);
            if (response.data.data.sellerid) {
              this.$store.commit(
                "userCategory",
                response.data.data.sellerid.category[0]
              );
              this.$store.commit(
                "userSubCategory",
                response.data.data.sellerid.subcategory
              );
            }
            this.$store.commit("userType", response.data.data.role);
            this.$store.commit("registrationStage", response.data.level);
            this.$store.commit("profilestatus", response.data.profileStatus);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    winStepper(windowData) {
      this.sideNav = windowData.sideNav;
    },
    winStepper2(windowData) {
      this.queryPopUpDialog = windowData.dialog;
      if (windowData.msg) {
        this.msg = windowData.msg;
        this.showSnackBar = true;
      }
    },
    getSettings() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/settings/getlist",
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            var settings = response.data.data;
            for (var i = 0; i < settings.length; i++) {
              if (settings[i].Name == "FacebookLink") {
                this.styloopData.facebook = settings[i].Value;
              }
              if (settings[i].Name == "InstagramLink") {
                this.styloopData.instagram = settings[i].Value;
              }
              if (settings[i].Name == "Gmail") {
                this.styloopData.gmail = settings[i].Value;
              }
              if (settings[i].Name == "Whatsapp") {
                this.styloopData.whatsapp = settings[i].Value;
              }
              if (settings[i].Name == "StyloopDescription") {
                this.styloopData.description = settings[i].Value;
              }
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
